export const RadioIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <circle cx='70.5' cy='91.5' r='17.5' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M101 91.5C101 87.0817 105.287 83.5 110.576 83.5H337.424C342.713 83.5 347 87.0817 347 91.5C347 95.9183 342.713 99.5 337.424 99.5H110.576C105.287 99.5 101 95.9183 101 91.5Z'
      fill='#A0AEC0'
    />
    <path
      d='M88 150.5C88 160.165 80.165 168 70.5 168C60.835 168 53 160.165 53 150.5C53 140.835 60.835 133 70.5 133C80.165 133 88 140.835 88 150.5Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M70.5 159C75.1944 159 79 155.194 79 150.5C79 145.806 75.1944 142 70.5 142C65.8056 142 62 145.806 62 150.5C62 155.194 65.8056 159 70.5 159ZM70.5 168C80.165 168 88 160.165 88 150.5C88 140.835 80.165 133 70.5 133C60.835 133 53 140.835 53 150.5C53 160.165 60.835 168 70.5 168Z'
      fill='#38B2AC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M101 150.5C101 146.082 105.287 142.5 110.576 142.5H337.424C342.713 142.5 347 146.082 347 150.5C347 154.918 342.713 158.5 337.424 158.5H110.576C105.287 158.5 101 154.918 101 150.5Z'
      fill='#38B2AC'
    />
    <circle cx='70.5' cy='209.5' r='17.5' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M101 209.5C101 205.082 105.287 201.5 110.576 201.5H337.424C342.713 201.5 347 205.082 347 209.5C347 213.918 342.713 217.5 337.424 217.5H110.576C105.287 217.5 101 213.918 101 209.5Z'
      fill='#A0AEC0'
    />
  </svg>
)
